import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from '@env/environment';
import { TranslateModule } from '@ngx-translate/core';
import { CreateCasePopupComponent } from 'app/shared/components/create-case-popup/create-case-popup.component';
import { InputSearchComponent } from 'app/shared/components/forms/fields/input-search/input-search.component';
import { LanguageSwitchComponent } from 'app/shared/components/language-switch/language-switch.component';
import { UserLoginComponent } from 'app/shared/components/user-login/user-login.component';
import { HelperService } from 'app/shared/services/helper.service';
import { Subject, takeUntil } from 'rxjs';
import { GlobalSearchComponent } from "../../shared/components/global-search/global-search.component";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EscalateCaseModalComponent } from 'app/shared/components/escalate-case-modal/escalate-case-modal.component';
import { SidebarService } from './sidebar.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    LanguageSwitchComponent,
    UserLoginComponent,
    CreateCasePopupComponent,
    CommonModule,
    RouterLink,
    RouterLinkActive,
    InputSearchComponent,
    TranslateModule,
    GlobalSearchComponent
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnDestroy {
  appVersion = environment.appVersion;
  reportBugIdeaDataRequestLink = environment.externalLinks.reportBugIdeaDataRequest;
  privacyPolicyLink = environment.externalLinks.privacyPolicy;

  sidebarConfig = [
    {
      link: '/',
      icon: 'bi bi-grid',
      title: 'label.dashboard',
      submenu: []
    },
    {
      link: '/create-new-case',
      icon: ' bi bi-plus',
      title: 'label.create_new_case',
      class: 'create-new-case-item',
      submenu: [],
      popup: true
    },
    {
      link: '/problem-records',
      icon: 'bi bi-file-earmark-text',
      title: 'label.problem_records',
      submenu: []
    },
    {
      link: '/help-page',
      icon: 'bi bi-shield',
      title: 'label.need_help',
      submenu: []
    },
    {
      link: '/knowledge-library',
      icon: 'bi bi-files',
      title: 'label.knowledge_library',
      submenu: []
    },
    {
      link: '/reports',
      icon: 'bi bi-graph-up-arrow',
      title: 'label.reports',
      navigateLink: '',
      submenuId: 'reports',
      submenu: [
        {
          submenuLink: '',
          submenuLinkExternal: environment.externalLinks.caseManagementActiveBacklog,
          submenuTitle: 'label.case-management-active-backlog',
          submenuIcon: 'bi bi-card-list',
        },
        {
          submenuLink: '',
          submenuLinkExternal: environment.externalLinks.caseManagementScorecard,
          submenuTitle: 'label.case-management-scorecard',
          submenuIcon: 'bi bi-card-checklist',
        },
      ]
    },
    {
      icon: 'bi bi-exclamation-triangle',
      title: 'label.escalate',
      escalate: true,
      submenu: []
    },
  ];

  private unsubscribe$ = new Subject<void>();

  constructor(public helperService: HelperService, private modalService: NgbModal, public sidebarService: SidebarService) {
    this.collapseSidebarSubscribe();
  }

  collapseSidebarSubscribe() {
    this.helperService.collapsedSidebarEmiter
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((data: boolean) => {
        this.helperService.collapsedSidebar = data;
      });
  }

  navigateToExternalLink(link: string) {
    window.open(link);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  openCreateCasePopup() {
    this.helperService.createCasePopoupVisible = true;
    this.helperService.isSidebar = true;
    if (window.innerWidth <= 576) {
      this.helperService.collapsedSidebar = true;
    }
  }

  escalateTicket() {
    this.modalService.open(EscalateCaseModalComponent, {
      backdrop: 'static',
      keyboard: false,
      modalDialogClass: 'escalate-modal'
    });
  }


}
